import { apiEndpoints, CommandResult, PortalSharedResourceSpec } from '../amorg-common';
import { commandAuthWrapper } from './serverApiHelpers';

export const sharedPortalResourceClientApi = {
    sharePortalResource: async (id: string, resourceId: string, spec: PortalSharedResourceSpec): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_shared_resources, 'POST', { id, resourceId, spec }),

    unsharePortalResource: async (id: string): Promise<CommandResult> =>
        await commandAuthWrapper(apiEndpoints.portal_shared_resources_id.replace(':id', id), 'DELETE'),
};
